import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { IconProps } from '@models/icons';
import { JSX, ReactNode } from 'react';

interface Props {
    icon: (props: IconProps) => JSX.Element;
    children?: ReactNode;
    selected?: boolean;
    onClick?: ()=>void;
}

function MenuShortcut({
    icon: Icon, children, selected, onClick,
}:Props) {
    const color = selected ? colors.gray7 : colors.gray5;
    return (
        <Menu onClick={onClick} >
            <Icon color={color}/>
            <Text fontWeight='bold' color={color}>
                {children}
            </Text>
        </Menu>
    );
}

const Menu = styled.button`
    align-items: center;
    background-color: transparent;
    column-gap: 3px;
    display: flex;
`;

export default MenuShortcut;
